












































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { DateTime } from 'luxon'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { Medico } from '@/types/_'
import moment from 'moment'
import { VAlert } from 'vuetify/lib'
import { stringToDecimal, onlyNumber } from '@/utils/common'

@Component
export default class ComponentRemuneracaoRightNavBar extends Vue {
  $refs: {
    menuFaturamento: any,
    menuRepasse: any,
  }

  fltLoading: boolean = false
  menuFaturamento: boolean = false
  menuRepasse: boolean = false

  get getMenuFaturamento() {
    return this.menuFaturamento
  }

  set getMenuFaturamento(value: boolean) {
    this.menuFaturamento = value
  }

  get getMenuRepasse() {
    return this.menuRepasse
  }

  set getMenuRepasse(value: boolean) {
    this.menuRepasse = value
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterDrawer(value)
  }

  get competenciaFaturamento() {
    return this.getStore.competenciaFaturamentoAnoMes
  }

  set competenciaFaturamento(value) {
    this.getStore.setCompetenciaFaturamento(value)
  }

  get competenciaRepasse() {
    return this.getStore.competenciaRepasseAnoMes
  }

  set competenciaRepasse(value) {
    this.getStore.setCompetenciaRepasse(value)
  }

  get codigoTuss() {
    return this.getStore.codigoTuss
  }

  set codigoTuss(value: string) {
    this.getStore.setCodigoTuss(value)
  }

  get getFontePagadoras() {
    return this.getStore.fontePagadoras
  }

  set getFontePagadoras(value: any[]) {
    this.getStore.setFontePagadora(value)
  }

  get fontePagadoraId() {
    return this.getStore.fontePagadoraId
  }

  set fontePagadoraId(value: string) {
    this.getStore.setFontePagadoraId(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPagina(1)
    await this.getStore.getRegistrosValidacao()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.competenciaFaturamentoAnoMes !== ''
      || this.getStore.fontePagadoraId !== '' || this.codigoTuss !== ''
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async clear() {
    await this.getStore.clearFiltroValidacao()
    await this.search()
    this.getStore.setFilterOn(false)
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
